import Sessions from "utils/Sessions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { filterProjectStatusFunc, normalizeParamsAndAddValues } from "utils/methods/methods";
import ApiService from "redux/ApiService/ApiService";

const getProjectMapData = createAsyncThunk("projectTracker/api", async (params, { signal }) => {
  const projectId = typeof params === "object" ? params?.projectId : params;
  const requestSignal = typeof params === "object" ? params?.signal || signal : signal;
  const endPoint = `reports/project-tracker-map-view/${projectId}`;
  const res = await ApiService.get(endPoint, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
    signal: requestSignal,
  });
  return res;
});

export const getProjectMapQhseData = createAsyncThunk(
  "getProjectMapQhseData/api",
  async (param) => {
    const projectStatus = filterProjectStatusFunc();
    const projectStatusObj = { projectStatus };

    const updatedParams = normalizeParamsAndAddValues(param, projectStatusObj);

    const res = await ApiService.get(`safety-cards?${updatedParams}`, {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    });
    return res.data;
  }
);

export const getProjectMapActivityData = createAsyncThunk(
  "getProjectMapActivityData/api",
  async (param) => {
    const res = await ApiService.get(
      `shifts/map-view?projectId=${param.project}&locationId=${param.location}`,
      {
        headers: { Authorization: `Bearer ${Sessions.userToken}` },
      }
    );
    return res.data;
  }
);

export const getProjectMapScopeWiseActivityHoursData = createAsyncThunk(
  "getProjectMapScopeWiseActivityHoursData/api",
  async (param) => {
    const res = await ApiService.get(
      `scopes/projects/${param.project}/locations/${param.location}`,
      {
        headers: { Authorization: `Bearer ${Sessions.userToken}` },
      }
    );
    return res.data;
  }
);

export default getProjectMapData;
